import { resolveImage as i } from "../../../helpers/index.js";
const t = (e) => ({
  ...i(e.properties?.image),
  caption: e.properties?.caption,
  captionAlign: "left"
});
export {
  t as pictureDeliveryApiParser
};
